<template>
  <s-dropdown-item
    :value="item.id"
    :class="{ 'pointer-events-none': isDisabled }"
    @click.stop="handleClick"
  >
    <span
      class="flex items-center gap-4 w-full"
      :class="{ 'text-disabled-variant-1': isDisabled, 'cursor-not-allowed': isDisabled }"
    >
      <span class="shrink-0">
        <slot name="prefix">
          {{ item.mode }}
        </slot>
      </span>
      <span class="flex-1 truncate">
        <st-tooltip-text-over position="bottom-start" :content="item.name">
          <slot name="content">
            <span class="truncate">{{ item.name }}</span>
          </slot>
        </st-tooltip-text-over>
      </span>
      <slot name="suffix"></slot>
    </span>
  </s-dropdown-item>
</template>

<script setup lang="ts">
import StTooltipTextOver from '@/components/common/st-tooltip-text-over.vue';

interface BuildItem {
  id: string;
  buildNo: number;
  description?: string;
  releaseStatus: string;
  mode: string;
  name: string;
  gameId: string;
  revisionTypes?: string;
  [key: string]: any;
}

const props = defineProps<{
  item: BuildItem;
  isDisabled?: boolean;
}>();

const emit = defineEmits<{
  click: [item: BuildItem];
}>();

const handleClick = (event: Event) => {
  // If disabled, prevent the event propagation but don't emit
  if (props.isDisabled) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  // Otherwise emit the click event with the item
  emit('click', props.item);
};
</script>
